import {Inject, Injectable} from "@angular/core";
import {ConnectionHttpService, ApiResourceLocation, SOFTLINE_SERVICE_HTTP} from "@softline/core";
import {Observable} from "rxjs";
import {SOFTLINE_API_LLR_KOMMISSIONIERUNG_SCAN_BESTELLUNGEN} from "../kommissionierung.api";
import {Bestellung} from "../types/bestellung";

@Injectable()
export class BestellungService {
  private scanBestellungLocation(type: string, code: string): ApiResourceLocation {
    return {
      path: SOFTLINE_API_LLR_KOMMISSIONIERUNG_SCAN_BESTELLUNGEN,
      pathParams: {
        type: type,
        code: code
      }
    }
  }

  constructor(
    @Inject(SOFTLINE_SERVICE_HTTP) private httpService: ConnectionHttpService
  ) {}

  scanBestellung(type: string, code: string): Observable<Bestellung> {
    const location = this.scanBestellungLocation(type, code);

    return this.httpService.get<Bestellung>(location);
  }
}
